import { APICore } from "./apiCore";

const api = new APICore();

// course
function addSubCourse(params: {
  name: string;
  courseId: string;
}) {
  const baseUrl = "/subcourse";
  return api.create(`${baseUrl}`, params);
}

function getSubCourse() {
  const baseUrl = "/subcourse";
  return api.get(`${baseUrl}`, {});
}

function updateSubCourse(
  id: number,
  params: { name: string; courseId: string }
) {
  const baseUrl = `/subcourse/${id}`;
  return api.update(`${baseUrl}`, params);
}

function deleteSubCourse(id: number) {
  const baseUrl = `/subcourse/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addSubCourse, deleteSubCourse, getSubCourse, updateSubCourse };
